import {
  ActivityFlowSection,
  LedgerPage,
  RelatedMaterialSection,
  SsBasicInfoSection,
  SsBudgetAndExecutionSection,
  SsInspectionEvaluationSection,
} from '@/features/mold/components';
import { PaymentSection } from '@/features/mold/components/pdf/rs-ledger/payment-section/PaymentSection';
import { PAPER_FILE_SIZE } from '@/features/mold/utils';
import type { FC } from 'react';
import type { useProjectLedgerData } from '../_hooks/useProjectLedgerData';

type Props = {
  projectId: string;
  ledgerData?: ReturnType<typeof useProjectLedgerData>;
  pageId?: string;
};

export const SsProjectLedgerPage: FC<Props> = ({ ledgerData, pageId }) => {
  // ledgerDataが渡されない場合は、以前の実装にフォールバック（互換性のため）
  if (!ledgerData) {
    return null;
  }

  const {
    isLoading,
    project,
    activityTreeOption,
    nestedConsecutiveIndicators,
    relatedMaterials,
    paymentGroups,
    paymentGraph,
    payments,
    data: { ss },
  } = ledgerData;

  // ローディング中または必要なデータがない場合はnullを返す
  if (isLoading || !project) {
    return null;
  }

  return (
    <LedgerPage width={PAPER_FILE_SIZE.A4.height} isLoading={false} id={pageId}>
      <SsBasicInfoSection ledgerData={ledgerData} />
      <SsBudgetAndExecutionSection
        project={project}
        segmentExpenditureAndExecution={ss.segmentExpenditureAndExecution}
        consecutiveFiscalYears={ss.consecutiveFiscalYears}
      />
      <ActivityFlowSection
        project={project}
        nestedConsecutiveIndicators={nestedConsecutiveIndicators}
        tree={activityTreeOption.tree.data}
        selectOptions={activityTreeOption.selectOptions}
      />
      <SsInspectionEvaluationSection project={project} />
      <PaymentSection
        project={project}
        paymentGraph={paymentGraph}
        paymentGroups={paymentGroups}
        payments={payments}
      />
      <RelatedMaterialSection relatedMaterials={relatedMaterials} />
    </LedgerPage>
  );
};
